package org.lennycodes.hldi.pages.admin

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.icons.fa.FaDeleteLeft
import com.varabyte.kobweb.silk.components.icons.fa.FaPen
import com.varabyte.kobweb.silk.style.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.*
import org.lennycodes.hldi.backend.db_service.ConfirmDeleteDialog
import org.lennycodes.hldi.backend.db_service.deleteAdmin
import org.lennycodes.hldi.backend.db_service.sendResetPassword
import org.lennycodes.hldi.backend.isUserLoggedIn
import org.lennycodes.hldi.data.Admin
import org.lennycodes.hldi.styles.*

// ----- Data -----

private fun initialsOf(fullName: String): String =
    fullName.split(" ")
        .filter { it.isNotBlank() }
        .take(2)
        .map { it.first().uppercaseChar() }
        .joinToString("")

// ----- Page -----

@Composable
fun Users() {
    val scope  = rememberCoroutineScope()
    var refreshKey by remember { mutableStateOf(0) }
    var admins by remember{
        mutableStateOf<List<Admin>>(emptyList())
    }
    var showDialog by remember { mutableStateOf(false) }
    var isEdit by remember { mutableStateOf(false) }
    var selectedAdmin by remember { mutableStateOf<Admin?>(null) }
    var selectedDeleteAdmin by remember { mutableStateOf<Admin?>(null) }
    if (showDialog) {
        AddAdminDialog(
            onDismiss = {
                showDialog = false
            },
            onSuccess = {
                refreshKey++
            }
        )
    }
          //Edit Admin Dialog
        selectedAdmin?.let { admin ->

            EditAdminDialog(
                admin = admin,

                onDismiss = {
                    selectedAdmin = null
                },

                onSuccess = {
                    refreshKey++
                    selectedAdmin = null
                }
            )

        }
       //Delete Admin Confirmation
    selectedDeleteAdmin?.let { admin ->

        ConfirmDeleteDialog(

            admin = admin,

            onDismiss = {
                selectedDeleteAdmin = null
            },

            onConfirm = {

                scope.launch {

                    deleteAdmin(
                        admin.email
                    )

                    refreshKey++

                    selectedDeleteAdmin = null

                }

            }
        )

    }
    LaunchedEffect(refreshKey){
        admins = AdminRepository.getAllAdmins()
    }
    Column(
        modifier = Modifier.fillMaxWidth() .padding(32.px),
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.Top
    ) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .padding(16.px),
            horizontalArrangement = Arrangement.SpaceBetween,
            verticalAlignment = Alignment.CenterVertically
        ) {

            H3(
                attrs = UsersTitleStyle.toAttrs()
            ) {
                Text("Admin List")
            }


            Button(
                modifier = Modifier
                    .padding(10.px, 20.px)
                    .then(AddAdminButtonStyle.toModifier()),

                onClick = {
                    // Open Add Admin dialog/page
                    showDialog = !showDialog
                }
            ) {
                Text("+ New Admin")
            }
        }

        Div(attrs = TableCardStyle.toAttrs()) {
            Table(attrs = AdminTableStyle.toAttrs()) {
                Thead {
                    Tr {
                        listOf("S/N", "Full Name", "Email", "Actions").forEach { title ->
                            Th(attrs = Modifier.padding(14.px, 16.px).then( TableHeaderCellStyle.toModifier()).toAttrs()) {
                                Text(title)
                            }
                        }
                    }
                }

                Tbody {
                    admins.forEachIndexed { index, admin ->
                        Tr(attrs = TableRowStyle.toAttrs()) {
                            Td(attrs = Modifier.padding(14.px, 16.px).then( TableCellStyle.toModifier()).toAttrs()) {
                                Text((index + 1).toString())
                            }

                            Td(attrs = Modifier.padding(14.px, 16.px).then( TableCellStyle.toModifier()).toAttrs()) {
                                Div(attrs = NameCellStyle.toAttrs()) {
                                    Span(attrs = AvatarBadgeStyle.toAttrs()) {
                                        Text(initialsOf(admin.fullName))
                                    }
                                    Text(admin.fullName)
                                }
                            }

                            Td(attrs = Modifier.padding(14.px, 16.px).then( TableCellStyle.toModifier()).toAttrs()) {
                                Text(admin.email)
                            }

                            Td(attrs = Modifier.padding(14.px, 16.px).then( TableCellStyle.toModifier()).toAttrs()){
                                Row(
                                    horizontalArrangement = Arrangement.spacedBy(8.px),
                                    verticalAlignment = Alignment.CenterVertically
                                ) {
                                    Button(
                                        modifier = Modifier.then(EditIconButtonStyle.toModifier())
                                            .then(IconButtonStyle.toModifier()),
                                        onClick = {
                                            selectedAdmin = admin
                                        /* Edit admin */
                                        }
                                    ) {
                                        FaPen()
                                    }

                                    Button(
                                        modifier =  Modifier.then(DeleteIconButtonStyle.toModifier())
                                            .then(IconButtonStyle.toModifier()),
                                        onClick = { /* Delete admin */
                                            selectedDeleteAdmin = admin
                                        }
                                    ) {
                                        FaDeleteLeft()
                                    }
                                    A(
                                        href = "#",
                                        attrs = {

                                            onClick { event ->

                                                event.preventDefault()

                                                scope.launch {

                                                    val success = sendResetPassword(
                                                        admin.email
                                                    )

                                                    if (success) {
                                                        console.log("Reset email sent")
                                                    } else {
                                                        console.log("Failed sending reset email")
                                                    }

                                                }
                                            }

                                        }
                                    ) {
                                        Text("Reset password")
                                    }

                                }
                            }
                        }
                    }
                }
            }
        }
    }
}